import { render, staticRenderFns } from "./meetingpoint.vue?vue&type=template&id=3813d0b6&scoped=true&"
import script from "./meetingpoint.vue?vue&type=script&lang=js&"
export * from "./meetingpoint.vue?vue&type=script&lang=js&"
import style0 from "./meetingpoint.vue?vue&type=style&index=0&id=3813d0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3813d0b6",
  null
  
)

export default component.exports